import { type HotkeyLayer } from '@/ui/utilities/hotkey/types/HotkeyLayer';

// Bottom to top. The page is always open; the side panel sits above it; an
// overlay (command menu, dialog, menu) sits above everything. A shortcut lists
// the layers it works on and only fires while the top-most open layer is one
// of them, so Esc in the command menu never also closes the side panel under it.
export const HOTKEY_LAYER_ORDER: readonly HotkeyLayer[] = [
  'page',
  'side-panel',
  'overlay',
];
